var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderAltDuotoneFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 9,
    rx: 2,
    fill: "#A4B6D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10H11.6569C10.8394 10 10.4306 10 10.0631 9.84776C9.69552 9.69552 9.40649 9.40649 8.82843 8.82843L8.82843 8.82843L8.03553 8.03553C7.59249 7.59249 7.37096 7.37096 7.10204 7.22962C6.99433 7.17301 6.88167 7.12635 6.76548 7.09022C6.47538 7 6.1621 7 5.53553 7C4.0972 7 3.37804 7 2.86576 7.35273C2.6649 7.49103 2.49103 7.6649 2.35273 7.86576C2 8.37804 2 9.0972 2 10.5355V18C2 19.8856 2 20.8284 2.58579 21.4142C3.17157 22 4.11438 22 6 22H18C19.8856 22 20.8284 22 21.4142 21.4142C22 20.8284 22 19.8856 22 18V7C22 7.93188 22 8.39782 21.8478 8.76537C21.6448 9.25542 21.2554 9.64477 20.7654 9.84776C20.3978 10 19.9319 10 19 10ZM6 14C5.44772 14 5 14.4477 5 15C5 15.5523 5.44772 16 6 16H14C14.5523 16 15 15.5523 15 15C15 14.4477 14.5523 14 14 14H6Z",
    fill: "#223979"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderAltDuotoneFill);
export default __webpack_public_path__ + "static/media/Folder_alt_duotone_fill.3b8b2c42.svg";
export { ForwardRef as ReactComponent };